module.exports = __webpack_public_path__ + "static/media/Breakingbad.d2907449.png";